import React from 'react';
import { Lock } from 'lucide-react';

/**
 * Full-width read-only ribbon that appears above locked exercise views.
 * Purely informational — the actual write-blocking happens on the backend
 * (middleware returns HTTP 423) and via disabled primary CTAs.
 */
const ExerciseLockedRibbon = ({ lockedByName, lockedAt, canManage = false }) => {
  const when = lockedAt ? new Date(lockedAt).toLocaleString() : null;
  return (
    <div
      data-testid="exercise-locked-ribbon"
      className="w-full bg-red-950/70 border border-red-500/50 rounded-md px-4 py-2 mb-4 flex items-start gap-3"
    >
      <Lock className="h-5 w-5 text-red-300 flex-shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <div className="text-red-200 font-semibold">
          This exercise is locked — read only.
        </div>
        <div className="text-red-300/80 text-xs mt-0.5">
          {lockedByName ? `Locked by ${lockedByName}` : 'Locked'}
          {when ? ` on ${when}` : ''}. All create, update and delete actions are disabled.
          {canManage ? ' Use the padlock icon above to unlock.' : ' Ask an Agency Admin or Super Admin to unlock.'}
        </div>
      </div>
    </div>
  );
};

export default ExerciseLockedRibbon;
